module.exports = __webpack_public_path__ + "static/media/dusty.a5cac672.svg";